import React, { useState } from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface CoverPhotoPositionProps {
  band: Band
}

interface CoverPhotoPositionOption {
  value: string | null
  label: string
}

export const CoverPhotoPosition: React.FC<CoverPhotoPositionProps> = ({
  band,
}) => {
  const [coverPhotoPosition, setCoverPhotoPosition] = useState<string | null>(
    band?.cover_photo_position || "center",
  )

  const COVER_PHOTO_POSITION_OPTIONS: CoverPhotoPositionOption[] = [
    { value: "top", label: "Top" },
    { value: "center", label: "Center" },
    { value: "bottom", label: "Bottom" },
  ]

  const notes = (
    <span>
      When your cover photo doesn't quite fit the space, this decides which
      edge stays visible - "Center" crops a little off both the top and
      bottom, "Top" always keeps the top of your photo in view (cropping the
      bottom instead), and "Bottom" does the opposite.
    </span>
  )

  const fieldData = {
    field: "cover_photo_position",
    name: "cover_photo_position",
    label: "Cover Photo Position",
    placeholder: "Cover Photo Position",
    required: true,
    notes: notes,
  }

  return (
    <EditBandFormField
      type="select"
      value={coverPhotoPosition}
      setValue={setCoverPhotoPosition}
      options={COVER_PHOTO_POSITION_OPTIONS}
      fieldData={fieldData}
      bandId={band.id}
      isArray={false}
    />
  )
}
